<template>
  <el-row :gutter="24">
    <el-col :span="9"><div class="grid-content bg-purple mast-center">  <img v-if="mast" :src="mast" > </div></el-col>
    <el-col :span="15"><div class="grid-content bg-purple">
      <p></p> <p></p> <p></p>
      <p>通讯地址：安徽省安庆市岳西县金翠兰广场</p>
      <p>联系电话：0556-3598062</p>
      <p>邮件地址：ahyouchen@qq.com</p>
         </div></el-col>
  </el-row>

</template>

<script>
import Mast from '@/assets/mast.png'
export default {
  name: 'About',
  data () {
    return {
      mast: Mast
    }
  }
}
</script>

<style scoped>
  .grid-content {
    border-radius: 15px !important;
    font-size: 1.2em;
    line-height: 2em;
  }
  .bg-purple {

  }
  p{
    margin-top: 2em;
    text-indent:2em;
  width: 25em;}
  .mast-center
  {
    text-align: right;
  }
  .mast-center img{
    max-width: 400px;
  }
</style>
